




















































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { loading, tc } from '@/decorators';
import ListTips from '@/components/listTips/index.vue';
@Component({
  components: {
    ListTips,
  },
})
export default class ApplyInvoicePage extends Vue {
  public visible: boolean = false;
  /** 是否有维护开票资料 */
  protected get hasBillData(): boolean {
    return !!this.billData.length;
  }
  /** 账单总金额为零或负数时的提示语 */
  private get zeroTip(): string {
    if (this.billType === this.$enum.common.BoolIntEnum.NO) {
      return this.t('本次账单消费为0或负数无法开票。');
    }
    return this.t('本次账单消费为0无法开票。');
  }
  /** 提示语 */
  private get tips(): string[] {
    const tips: string[] = [];
    if (this.billType === this.$enum.common.BoolIntEnum.NO) {
      if (Number(this.totalRmbAmount) <= 0 && !this.rmbAmountLoading) {
        tips.push(this.zeroTip);
      }
    } else {
      if (this.isShowZeroTip) {
        tips.push(this.zeroTip);
      }
    }
    let timeList: string[] = [];
    this.data.forEach((item) => {
      item.bill_from_time && timeList.push(item.bill_from_time.slice(0, 7));
      item.bill_to_time && timeList.push(item.bill_to_time.slice(0, 7));
    });
    timeList = this.$util.arrayUnique(timeList);
    if (timeList.length > 1) {
      tips.push(this.t('发票将根据申请月份总应开票金额开具发票；如需按月开票,请单独按月份申请。'));
    }
    return tips;
  }
  /** 账户编码 */
  protected get accountCode(): string {
    return this.data[0].sign_body_info?.account_code as string;
  }
  protected count: number = 1;
  protected columns: TypeBase.TableColumn[] = [];
  protected tbodyData: TypeReconciliationBill.ApplyInvoiceData[] = [];
  protected reconciliationNumberList: string[] = [];
  /** id列表 */
  protected idList: string[] = [];
  /**
   * 备注说明
   */
  protected customerRemark: string = '';
  /** 发票类型，0：增值税发票 1：形式发票 */
  protected billType: number = this.$enum.common.BoolIntEnum.YES;
  /** 详情接口请求状态 */
  protected loadingStatus: boolean = true;
  /** 汇总人民币 */
  protected totalRmbAmount: string = '';
  /** 获取人民币 */
  protected rmbAmountLoading: boolean = false;
  /** 开票资料列参数 */
  protected billDataColumns: TypeBase.TableColumn[] = [];
  /** 开票资料 */
  protected billData: TypeBillData.ListItem[] = [];
  /** 获取开票资料请求状态 */
  protected billDataLoading: boolean = false;
  /** 形式发票为零（所有币种都为0时才是0，正负数相加等于零的情况不纳入这种情况） */
  protected isShowZeroTip: boolean = false;
  @Prop({ type: Array, default: () => [] })
  protected data!: TypeReconciliationBill.ListItem[];

  @Watch('data', { immediate: true })
  protected onDataChange(data: TypeReconciliationBill.ListItem[]): void { }
  @Watch('visible', { immediate: true })
  protected async onVisibleChange(isShow: boolean): Promise<void> {
    if (isShow) {
      // 由于列表数据有误，需要请求一次详细的数据
      if (this.data.length > 0) {
        this.count = this.data.length;
        this.reconciliationNumberList = this.data.map((item: TypeReconciliationBill.ListItem) => item.reconciliation_number);
        const idList: string[] = this.data.map((item: TypeReconciliationBill.ListItem) => item.reconciliation_id.toString());
        this.idList = idList || [];
        await this.queryDetail(idList);
        this.getTotalAmount(idList);
      } else {
        this.tbodyData = [];
      }
      await this.queryBillDataList();
      this.setBillDataTableSetings();
    } else {
      this.customerRemark = '';
      this.totalRmbAmount = '';
      this.isShowZeroTip = false;
    }
  }
  protected async applyInvoice(): Promise<void> {
    const { code, message } = await this.$api.finance.applyInvoice({
      reconciliation_number_list: this.reconciliationNumberList,
      reconciliation_id_list: this.idList,
      customer_remark: this.customerRemark,
      account_code: this.accountCode,
    });
    if (code === 0) {
      this.visible = false;
      this.$emit('success');
    } else {
      this.$message.error(message);
    }
  }
  // 确认点击
  protected handleOk(): void {
    this.applyInvoice();
  }
  /** 取消 */
  protected handleClose(): void {
    this.visible = false;
  }
  protected created() { }
  @loading('loadingStatus')
  protected async queryDetail(idList: string[]): Promise<void> {
    const dataList: any = [];
    const promiseList: any[] = [];
    idList.map(async (item: string) => {
      promiseList.push(this.$api.finance.queryReconciliationDetail({ id: item }));
    });
    const res = await Promise.all(promiseList);
    res.map((item: any) => {
      dataList.push(item.data.bill_money);
    });
    this.billType = res[0].data.bill_detail.bill_type;
    const listItem: TypeReconciliationBill.ListItem[] = dataList;
    this.setColumn(dataList);
    const amountData: TypeReconciliationBill.ApplyInvoiceData = {};
    this.columns.forEach((item: TypeBase.TableColumn) => {
      let sum: number = 0;
      listItem.forEach((child: TypeReconciliationBill.ListItem) => {
        child.pending_invoice_tax_inclusive instanceof Array &&
          child.pending_invoice_tax_inclusive.forEach((c: TypeReconciliationBill.BillCurrency) => {
            if (c.currency_code === item.dataIndex) {
              sum += Number(c.currency_value);
            }
          });
      });
      if (item.dataIndex) {
        amountData[item.dataIndex] = sum.toFixed(3);
      }
    });
    this.tbodyData = [amountData];
  }
  /**
   * 获取人民币汇总金额
   */
  @loading('rmbAmountLoading')
  protected async getRmbAmount(idList: string[]): Promise<void> {
    const { data } = await this.$api.finance.getRmbAmount<string>({ reconciliation_number_list: this.reconciliationNumberList });
    this.totalRmbAmount = data || '';
  }
  /**
   * 获取总金额
   */
  private getTotalAmount(idList: string[]) {
    if (this.billType === this.$enum.common.BoolIntEnum.NO) {
      this.getRmbAmount(idList);
    } else {
      const values = Object.values(this.tbodyData[0]);
      /** 是否所有都为零 */
      const isZero: boolean = values.every((item: string) => {
        return Number(item) === 0;
      });
      this.isShowZeroTip = isZero;
    }
  }
  /**
   * 设置币种列
   */
  private setColumn(dataList: any[]): void {
    let fileds: string[] = [];
    dataList.forEach((item: any) => {
      item.pending_invoice_tax_inclusive &&
        item.pending_invoice_tax_inclusive.forEach((child: any) => {
          if (child.currency_value && Number.parseFloat(child.currency_value) != 0) {
            fileds.push(child.currency_code);
          }
        });
    });
    fileds = this.$util.arrayUnique(fileds);
    const columns: TypeBase.TableColumn[] = [];
    fileds.forEach((item) => {
      columns.push({
        title: item,
        align: 'right',
        dataIndex: item,
        width: 150,
      });
    });
    this.columns = columns;
  }
  /**
   * 设置开票资料列表相关配置
   */
  private setBillDataTableSetings(): void {
    this.billDataColumns = [
      {
        title: this.t('抬头'),
        dataIndex: 'title',
        filterEmpty: true,
      },
      {
        title: this.t('税号'),
        dataIndex: 'tax_no',
        filterEmpty: true,
      },
      {
        title: this.t('地址'),
        dataIndex: 'address',
        filterEmpty: true,
      },
      {
        title: this.t('电话'),
        dataIndex: 'phone',
        filterEmpty: true,
      },
      {
        title: this.t('开户行'),
        dataIndex: 'open_bank_name',
        filterEmpty: true,
      },
      {
        title: this.t('账号'),
        dataIndex: 'open_bank_account',
        filterEmpty: true,
      },
    ];
    this.$nextTick(() => {
      if (!this.$refs.billData) {
        return;
      }
      const h = this.$createElement;
      (this.$refs.billData as any).locale.emptyText = (
        <div>
          <span>{this.tc('请先维护开票资料')}</span>
        </div>
      );
    });
  }
  /**
   * 请求列表数据
   */
  @loading('billDataLoading')
  private async queryBillDataList(): Promise<void> {
    this.billData = [];
    const { data } = await this.$api.finance.queryBillDataList<TypeBase.ListResult<TypeBillData.ListItem[]>>({
      account_code: this.accountCode,
      page_index: 1,
      page_size: 10,
    });
    const { list, total } = data;
    this.billData = list;
  }
  /**
   * 新增开票资料
   */
  private handleAddBillData() {
    this.$router.push({ name: 'BillDataPage' });
    this.visible = false;
  }
}
